module.exports = __webpack_public_path__ + "static/media/tavern.2469b4c5.png";